import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Mode Isolation",
  viewBox: "0 0 86.76 85.04"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M40.22 58.24c-18.3-26.4-21.2-64-2.1-57.5 19.2 6.6 46.3 26.2 2.1 57.5",
      style: {"fill":"#00ace7"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M40.22 58.24c-18.1 12-42.8 13-40 2 2.9-11.6 14.7-29.5 40-2",
      style: {"fill":"#13529f"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M41.52 60.34c5.7 9.7 19.6 13.6 30.2 3.3 14.4-14 35.5-44.5-30.2-3.3",
      style: {"fill":"#66c9ef"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M41.52 60.34c-14.2 9.5-25.6 24.8-18.7 24.7 7-.2 23.9-9.6 18.7-24.7",
      style: {"fill":"#647ebd"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "BF-logo"}) } }